<main>
  <loading-overlay [isLoading]="isLoading() > 0"></loading-overlay>

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>{{ 'Work_Orders_For_Production_Cards' | translateWF: 'Production Cards for Work Orders' }}</h1>
      </div>
    </div>

    <div class="cs-page-list-grid">
      @if (filterConfig() && showFilters()) {
        <csl-dynamic-filters [filterConfig]="filterConfig()!" [state]="filterState" />
      }

      <p-panel [header]="'Work_Orders_For_Production_Cards' | translateWF: 'Production Cards for Work Orders'">
        <ng-template pTemplate="icons">
          <p-button
            [label]="(showFilters() ? 'Common_Hide_Filters' : 'Common_Show_Filters') | translateWF: (showFilters() ? 'Hide Filters' : 'Show Filters')"
            [icon]="showFilters() ? 'pi pi-filter-slash' : 'pi pi-filter'"
            (click)="showFilters.set(!showFilters())"
            variant="outlined"
            size="small"
          />
        </ng-template>
        <p-card data-variant="compact">
          <p-table [value]="workOrders()" dataKey="id" [lazy]="true" (onSort)="onSort($event)" selectionMode="single" [rowHover]="true" styleClass="cs-datatable-col-200">
            <ng-template pTemplate="header">
              <tr>
                <th>
                  {{ 'WorkOrder-Table.status' | translateWF: 'Status' }}
                </th>
                <th pSortableColumn="orderNumber">
                  {{ 'WorkOrder-Table.number' | translateWF: 'Number' }}
                  <p-sortIcon field="orderNumber" />
                </th>
                <th>
                  {{ 'WorkOrder-Table.customer' | translateWF: 'Customer' }}
                </th>
                <th>
                  {{ 'WorkOrder-Table.brand' | translateWF: 'Brand' }}
                </th>
                <th>
                  {{ 'WorkOrder-Table.customerProductOrders' | translateWF: 'Customer Product Order(s)' }}
                </th>
                <th>
                  {{ 'WorkOrder-Table.orderType' | translateWF: 'Order Type' }}
                </th>
                <th>
                  {{ 'WorkOrder-Table.knittingDates' | translateWF: 'Knitting Date(s)' }}
                </th>
                <th>
                  {{ 'WorkOrder-Table.dyeingDates' | translateWF: 'Dyeing Date(s)' }}
                </th>
                <th>
                  {{ 'WorkOrder-Table.finishingDates' | translateWF: 'Finishing Date(s)' }}
                </th>
                <th>
                  {{ 'WorkOrder-Table.yarnLatestReception' | translateWF: 'Yarn Latest Reception' }}
                </th>
                <th>
                  {{ 'WorkOrder-Table.relatedProductOrders' | translateWF: 'Related Product Orders' }}
                </th>
                <th>
                  {{ 'WorkOrder-Table.knittingEstimated' | translateWF: 'Knitting Estimated' }}
                </th>
                <th>
                  {{ 'WorkOrder-Table.plannedKnittingEstimated' | translateWF: 'Planned Knitting Estimated' }}
                </th>
                <th>
                  {{ 'WorkOrder-Table.estimatedPlanning' | translateWF: 'Estimated Planning' }}
                </th>
                <th>
                  {{ 'WorkOrder-Table.planned' | translateWF: 'Planned' }}
                </th>
                <th>
                  {{ 'WorkOrder-Table.productionCardsCount' | translateWF: 'Production Cards Count' }}
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-index="rowIndex">
              @let order = getRowData(rowData);
              <tr class="cursor-pointer" (click)="redirectToDetails(order.id)">
                <td>{{ orderStatusEnums[order.status] }}</td>
                <td>
                  <a>{{ order.orderNumber }}</a>
                </td>
                <td>{{ order.customer?.name }}</td>
                <td>{{ order.brand?.name }}</td>
                <td>{{ getCustomerProductOrder(order) }}</td>
                <td>{{ orderTypesEnums[order.orderType] }}</td>

                <td>
                  <div>
                    <div class="text-xs font-semibold text-gray-600">
                      {{ 'WorkOrder-Table.LatestStartDate' | translateWF: 'Latest Start Date' }}
                    </div>
                    <div class="text-sm">{{ order.estimatedDatesPlanning?.knittingLatestStartDate | date: 'dd/MM/yyyy' }}</div>
                  </div>
                  <div>
                    <div class="text-xs font-semibold text-gray-600">
                      {{ 'WorkOrder-Table.EstimatedEndDate' | translateWF: 'Estimated End Date' }}
                    </div>
                    <div class="text-sm">{{ order.estimatedDatesPlanning?.knittingEstimatedEndDate | date: 'dd/MM/yyyy' }}</div>
                  </div>
                </td>
                <td>
                  <div>
                    <div class="text-xs font-semibold text-gray-600">
                      {{ 'WorkOrder-Table.LatestStartDate' | translateWF: 'Latest Start Date' }}
                    </div>
                    <div class="text-sm">{{ order.estimatedDatesPlanning?.dyeingLatestStartDate | date: 'dd/MM/yyyy' }}</div>
                  </div>
                  <div>
                    <div class="text-xs font-semibold text-gray-600">
                      {{ 'WorkOrder-Table.EstimatedEndDate' | translateWF: 'Estimated End Date' }}
                    </div>
                    <div class="text-sm">{{ order.estimatedDatesPlanning?.dyeingEstimatedEndDate | date: 'dd/MM/yyyy' }}</div>
                  </div>
                </td>
                <td>
                  <div>
                    <div class="text-xs font-semibold text-gray-600">
                      {{ 'WorkOrder-Table.LatestStartDate' | translateWF: 'Latest Start Date' }}
                    </div>
                    <div class="text-sm">{{ order.estimatedDatesPlanning?.finishingLatestStartDate | date: 'dd/MM/yyyy' }}</div>
                  </div>
                  <div>
                    <div class="text-xs font-semibold text-gray-600">
                      {{ 'WorkOrder-Table.EstimatedEndDate' | translateWF: 'Estimated End Date' }}
                    </div>
                    <div class="text-sm">{{ order.estimatedDatesPlanning?.finishingEstimatedEndDate | date: 'dd/MM/yyyy' }}</div>
                  </div>
                </td>
                <td>{{ order.estimatedDatesPlanning?.yarnLatestReceptionDate | date: 'dd/MM/yyyy' }}</td>
                <td>PO-124</td>
                <td>{{ order?.totalQuantities?.totalEstimatedKnittingQuantity || 0 | number: '1.0-2' }} Lbs</td>
                <td>{{ order?.totalQuantities?.totalPlannedKnittingQuantity || 0 | number: '1.0-2' }} Lbs</td>
                <td>{{ order?.totalQuantities?.totalEstimatedPlanningQuantity || 0 | number: '1.0-2' }} Lbs</td>
                <td>{{ order?.totalQuantities?.totalActualPlannedQuantity || 0 | number: '1.0-2' }} Lbs</td>
                @if (workOrderProductionCard[order.id] && workOrderProductionCard[order.id].length > 0) {
                  <td>{{ workOrderProductionCard[order.id].length }}</td>
                } @else {
                  <td>0</td>
                }
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="16">
                  {{ 'No_work_orders_found' | translateWF: 'No work orders found' }}
                </td>
              </tr>
            </ng-template>
          </p-table>

          <p-paginator
            [rows]="pageSize()"
            [totalRecords]="totalRecords()"
            [first]="(currentPage() - 1) * pageSize()"
            (onPageChange)="onPageChange($event)"
            [rowsPerPageOptions]="[15, 20, 30]"
            class="mt-4"
          />
        </p-card>
      </p-panel>
    </div>
  </div>
</main>

<p-toast position="top-center" />
